// const jsonpack = require('jsonpack/main');
import _ from "linq";

export function put(key, value) {
  try {
    if (key.endsWith("-map")) return;
  } catch (e) {}

  let str;
  try {
    str = JSON.stringify(value);
  } catch (e) {
    str = value;
  }
  localStorage.removeItem(key);
  try {
    localStorage.setItem(key, str);
  } catch (e) {
    if (key !== "students") {
      localStorage.removeItem("students");
      localStorage.setItem(key, str);
      return;
    }

    throw e;
  }
}

export function linq(key) {
  const value = get(key);
  return _.from(Array.isArray(value) ? value : []);
}

export function from(key) {
  const value = get(key);
  return _.from(Array.isArray(value) ? value : []);
}

export function select(key, id = undefined) {
  const value = get(key);
  const records = Array.isArray(value) ? value : [];
  if (id) return _.from(records).firstOrDefault((r) => r.id == id);
  return _.from(records);
}

export function get(key, group = undefined) {
  if (group !== undefined) return keyValue(get(key), group);

  try {
    if (key.endsWith("-map")) {
      //todo:
      return map(key.replace("-map", ""));
    }
  } catch (e) {}

  let str = localStorage.getItem(key);
  try {
    let obj = JSON.parse(str);
    return obj;
  } catch (e) {
    return str;
  }
}

export function get2(key, group = undefined) {
  if (group !== undefined) return keyValue(get(key), group);

  try {
    if (key.endsWith("-map")) {
      //todo:
      return map(key.replace("-map", ""));
    }
  } catch (e) {}

  let str = localStorage.getItem(key);
  try {
    let obj = new Map(JSON.parse(str));
    return obj;
  } catch (e) {
    return str;
  }
}

export function map(key) {
  let str = localStorage.getItem(key);
  try {
    let obj = JSON.parse(str);
    return keyValue(obj);
  } catch (e) {
    return {};
  }
}

export function exists(key) {
  return localStorage.getItem(key) !== null;
}

export function missing(key) {
  return !exists(key);
}

export function remove(key) {
  try {
    if (exists(key)) {
      localStorage.removeItem(key);
      return true;
    }
  } catch (e) {}
  return false;
}

export function keyValue(arr, key = "id") {
  if (arr == null) return {};

  if (!Array.isArray(arr)) {
    return {};
  }

  let obj = {};
  arr.forEach((v) => {
    obj[v[key]] = v;
  });
  return obj;
}

export default {
  put,
  get,
  exists,
  missing,
  remove,
  map,
  from,
  linq,
};
